import { defineMessages } from "react-intl";

export const messages = defineMessages({
	name: {
		id: "dashboard.name",
		defaultMessage: "Páciens neve"
	},
	maidenNameOfMother: {
		id: "dashboard.maiden_name_of_mother",
		defaultMessage: "Anyja leánykori neve"
	},
	statementOfConsentAlert: {
		id: "dasboard.statement_of_consent_alert",
		defaultMessage:
			"A páciens beleegyező nyilatkozata nem került feltöltésre!"
	},
	status: {
		id: "dashboard.status",
		defaultMessage: "Státusz"
	},
	waitingList: {
		id: "dashboard.waiting_list",
		defaultMessage: "Várólistán"
	},
	patientEtId: {
		id: "dashboard.patient_et_id",
		defaultMessage: "ET azonosító"
	},
	ssn: {
		id: "dashboard.social_security_number",
		defaultMessage: "TAJ"
	},
	address: {
		id: "dashboard.address",
		defaultMessage: "Lakhely"
	},
	phoneNumber: {
		id: "dashboard.phone_number",
		defaultMessage: "Telefon"
	},
	bloodGroup: {
		id: "dashboard.blood_group",
		defaultMessage: "Vércsoport"
	},
	dateOfBirth: {
		id: "dashboard.date_of_birth",
		defaultMessage: "Születési dátum"
	},
	age: {
		id: "dashboard.age",
		defaultMessage: "Életkor"
	},
	weight: {
		id: "dashboard.weight",
		defaultMessage: "Testsúly"
	},
	height: {
		id: "dashboard.height",
		defaultMessage: "Magasság"
	},
	bmi: {
		id: "dashboard.bmi",
		defaultMessage: "BMI"
	},
	pvr: {
		id: "dashboard.pvr",
		defaultMessage: "PVR"
	},
	thoracotomia: {
		id: "dashboard.thoracotomia",
		defaultMessage: "Thoracotomia"
	},
	combinedTransplant: {
		id: "dashbaord.combined_transplant",
		defaultMessage: "Kombinált TX"
	},
	hyperImmunised: {
		id: "dashboard.hyper_immunised",
		defaultMessage: "Hyperimmun"
	},
	dashboard: {
		id: "dashboard.dashboard",
		defaultMessage: "Dashboard"
	},
	editPatient: {
		id: "dashboard.edit_patient",
		defaultMessage: "Páciens adatainak szerkesztése"
	},
	timeline: {
		id: "dashboard.timeline",
		defaultMessage: "Idővonal"
	},
	report: {
		id: "dashboard.report",
		defaultMessage: "Riport"
	}
});
